import * as Yup from "yup";
import { addressSchema, citySchema, stateSchema } from "utils/schemas";

const ALLOWED_MIME_TYPES = ["image/png", "image/jpeg", "application/pdf"];
const ALLOWED_EXTENSIONS = [".png", ".jpg", ".jpeg", ".pdf"];

function isAllowedFile(file: unknown): boolean {
  if (!file || !(file instanceof File)) return true;
  const ext = ("." + (file.name.split(".").pop() ?? "")).toLowerCase();
  return ALLOWED_MIME_TYPES.includes(file.type) && ALLOWED_EXTENSIONS.includes(ext);
}

const checklistItemSchema = Yup.object({
  label: Yup.string().optional().default(""),
  finding: Yup.string().nullable().optional().default(null),
  isCompleted: Yup.boolean().optional().default(false),
  sortOrder: Yup.number().optional().default(0),
});

export function getEnquirySiteVisitFormSchema(_isEditMode: boolean) {
  return Yup.object({
    enquiryId: Yup.string().required("The enquiry field is required"),
    scheduledAt: Yup.string().optional().nullable(),
    address: addressSchema,
    city: citySchema,
    state: stateSchema,
    description: Yup.string(),
    priority: Yup.string()
      .oneOf(["LOW", "MEDIUM", "HIGH"], "Invalid priority")
      .required("Priority is required"),
    checklist: Yup.array().of(checklistItemSchema).optional().default([]),
    files: Yup.array()
      .of(
        Yup.mixed<File>().test(
          "file-type",
          "Only PNG, JPG, JPEG, or PDF files are accepted",
          isAllowedFile,
        ),
      )
      .optional()
      .nullable(),
    deletedFiles: Yup.array().of(Yup.number()).optional().nullable(),
  });
}
